module.exports = __webpack_public_path__ + "img/dashboard.d87b1fb5.svg";